'use client'
import { useImageWithCache } from '@/app/minha-area/_hooks/useImageWithCache'
import Image from 'next/image'
import { HistoryPhotoEditButton } from './HistoryPhotoEditButton'
import MyHistory from './MyHistory'
interface HistorySectionProps {
	about: string
	historyPhotoCurrent: string | null
	profileId: number
	isEditable: boolean
}

export function HistorySection({ about, historyPhotoCurrent, profileId, isEditable }: HistorySectionProps) {
	const whichPhotoToShow = historyPhotoCurrent || '/default/history.jpeg'

	const [historyPhoto, setHistoryPhoto] = useImageWithCache('history', whichPhotoToShow)

	return (
		<div className="flex flex-col xl:flex-row mt-8 sm:mt-12 md:mt-16 xl:mt-0 mx-2 sm:mx-4 md:mx-8 xl:mx-36 relative gap-4 xl:gap-0">
			<div className="w-full xl:w-1/2">
				<MyHistory about={about} title="Minha história" />
			</div>

			<div className="flex-1 flex items-center justify-center relative min-h-[200px] sm:min-h-[300px] xl:min-h-[400px]">
				<Image
					width={400}
					height={400}
					src="/image-background.svg"
					alt="Background"
					className="w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] lg:w-[500px] lg:h-[500px] xl:w-[600px] xl:h-[600px]"
					style={{
						transform: 'scaleX(-1)',
					}}
				/>
				<Image
					width={300}
					height={300}
					src={historyPhoto}
					alt="Tia grávida"
					className="absolute w-[250px] h-[250px] sm:w-[320px] sm:h-[320px] lg:w-[400px] lg:h-[400px] xl:w-[450px] xl:h-[450px]"
					style={{
						maskImage: "url('/image-background.svg')",
						maskSize: 'contain',
						maskRepeat: 'no-repeat',
						maskPosition: 'center',
					}}
				/>
				<HistoryPhotoEditButton id={profileId.toString()} isEditable={isEditable} setImageUrl={setHistoryPhoto} />
			</div>
		</div>
	)
}
